module.exports = __webpack_public_path__ + "static/media/SHI-Logo.39641b8a.png";